import { generateClassName } from '@klv/shared/utils/functions';
import { useTranslation } from '@klv/hooks/useTranslation';
import Icon from '@klv/atoms/icon';
import { FieldGroup, Select } from '@klv/molecules/form-field';

import * as styles from './styles/tabbed-content-mobile-select.module.scss';

import type { ITabs } from './types';

export const TabbedContentMobileSelect = ({
  className = '',
  activeTab,
  setActiveTab,
  tabs,
}: ITabs) => {
  const { t } = useTranslation();
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setActiveTab(parseInt(event.target.value, 10));
  };

  return (
    <div className={generateClassName([styles.mobileSelectContainer, className])}>
      <FieldGroup className={generateClassName([styles.selectFieldGroup, 'light'])}>
        <Icon
          className={generateClassName([styles.selectArrow, 'light', 'selectArrow'])}
          iconName="ChevronDown"
          fillColor="currentColor"
          aria-hidden="true"
        />
        <Select
          $backgroundColor="light"
          hasError={false}
          id="mobile-tab-select"
          name="mobile-tab-select"
          value={activeTab}
          onChange={handleSelectChange}
          aria-label={t('molecules_tabbedContentTabs_mobileSelect_ariaLabel')}
        >
          {tabs.map((tabLabel, index) => (
            <option key={tabLabel} value={index}>
              {tabLabel}
            </option>
          ))}
        </Select>
      </FieldGroup>
    </div>
  );
};
